import { useSidebarContext } from './SidebarContext';
import { isSidebarLinkActive } from './isSidebarLinkActive';
import { useSidebarUrl } from './useSidebarUrl';

export const useIsActiveLink = (link: string): boolean => {
  const { isActive, menuLinks } = useSidebarContext();
  const currentUrl = useSidebarUrl(menuLinks);

  return isSidebarLinkActive(currentUrl, link, menuLinks, isActive);
};
